import { styled } from '$utils/theme'
import { Block } from '$views/components'
import { Container } from '$views/components/Layout/Container'
import { rem } from 'polished'
import { FormContainer } from '$views/components/FormContainer'

export const StyledContainer = styled(Container)`
  top: 0;
  margin-bottom: 0;
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0;
  ${p => p.theme.media.desktop`
      margin-top: ${rem(p.theme.sizes.mini)};
      margin-bottom: ${rem(p.theme.sizes.base)};
  `}
  ${p => p.theme.media.onlyMobile`
        margin-bottom: ${rem(p.theme.sizes.mini)};
  `};
`

export const StyledGreenBlock = styled(Block)`
  background-color: ${p => p.theme.colors.xlightGreen};
  padding: ${p => rem(p.theme.sizes.small)} 0 ${p => rem(p.theme.sizes.base)} 0;
  ${p => p.theme.media.desktop`
    margin-top: ${rem(p.theme.sizes.large)};
    padding: ${rem(p.theme.sizes.mini)} 0 ${rem(p.theme.sizes.small)} 0;
  `}
  width: 100%;
`

export const StyledFormContainer = styled(FormContainer)`
  margin-top: 0;
`



// WEBPACK FOOTER //
// ./src/views/CaretakerRecommendation/Components/ShareSection/ShareSection.style.ts